import React, { PropsWithChildren, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface EntityPreviewProps {
  className?: string
}

export const EntityPreview = ({
  children,
  className,
}: PropsWithChildren<EntityPreviewProps>) => {
  return (
    <div
      className={twMerge(
        'rounded-lg border border-border200 bg-bgSecondary px-12 py-3',
        className,
      )}
    >
      {children}
    </div>
  )
}
